import config from './config'
import { CAMPAIGN_TYPE_CODES, TEMPLATE_TYPE_CODES } from '../consts'

const _createCampaign = (objType, objId) => {
    let body = {
        obj_type: objType,
        obj_id: objId,
    }
    return config.post('/api/campaigns/v2/', body)
}

export const CampaignAPI = {
    get: (campaignId) => {
        console.log('fetching campaign details id:', campaignId)
        return config.get(`/api/campaigns/v2/${campaignId}/`)
    },

    getAll: () => {
        console.log('fetching campaigns...')
        return config.get(`/api/campaigns/v2/`)
    },

    delete: (campaignId) => {
        return config.delete(`/api/campaigns/v2/${campaignId}`)
    },

    getAllAssets: (campaignId) => {
        console.log('fetching campaign assets id:', campaignId)
        return config.get(`/api/campaigns/${campaignId}/assets/`)
    },

    getScheduledAssets: (start, end) => {
        return config.get(`/api/campaigns/calendar/?start=${start}&end=${end}`)
    },

    createAsset: (campaignId, dataUrl, postData, canvas) => {
        let body = {
            dataUrl: dataUrl,
            postData: postData,
            canvas: canvas,
        }

        return config.post(`/api/campaigns/${campaignId}/assets/`, body)
    },

    createAssetV2: (campaignId, fileUrl, canvas) => {
        let body = {
            file_url: fileUrl,
            canvas: canvas,
        }

        return config.post(`/api/campaigns/${campaignId}/assets/`, body)
    },

    getAsset: (campaignId, assetId) => {
        return config.get(`/api/campaigns/${campaignId}/assets/${assetId}/`)
    },

    deleteAsset: (campaignId, assetId) => {
        return config.delete(`/api/campaigns/${campaignId}/assets/${assetId}/`)
    },

    updateAsset: (campaignId, assetId, body) => {
        return config.put(
            `/api/campaigns/${campaignId}/assets/${assetId}/`,
            body
        )
    },

    // HACK: I'm hacking put vs patch for different scenarios and not using
    // it in true REST fashion. Fix soon.
    updateAssetV2: (campaignId, assetId, dataUrl, canvas) => {
        let body = {
            dataUrl: dataUrl,
            canvas: canvas,
        }
        return config.patch(
            `/api/campaigns/${campaignId}/assets/${assetId}/`,
            body
        )
    },

    extractBlog: (url) => {
        return config.post(`/api/campaigns/extract_article/`, { url: url })
    },

    extractProduct: (url) => {
        return config.post(`/api/campaigns/extract_product/`, { url: url })
    },

    createBlogPost: (title, articleId) => {
        return config.post(`/api/campaigns/blog_posts/`, {
            title: title,
            article_id: articleId,
        })
    },

    createListing: (title, productId) => {
        return config.post(`/api/campaigns/listings/`, {
            title: title,
            product_id: productId,
        })
    },

    createQuoteGroup: (title, aiPrompt) => {
        return config.post(`/api/campaigns/quote_groups/`, {
            title: title,
            prompt: aiPrompt,
        })
    },

    createPosts: (extractGuid) => {
        return config.post('/api/campaigns/create_article_posts/', {
            id: extractGuid,
        })
    },

    createBlogCampaign: (blogId) => {
        return _createCampaign(TEMPLATE_TYPE_CODES.BLOG, blogId)
    },

    createListingCampaign: (listingId) => {
        return _createCampaign(CAMPAIGN_TYPE_CODES.LISTING, listingId)
    },

    createQuotesCampaign: (quoteId) => {
        return _createCampaign(TEMPLATE_TYPE_CODES.TEXT, quoteId)
    },

    createCustomAsset: (
        url,
        source_type,
        publishTo,
        caption,
        schedule_date
    ) => {
        return config.post(`/api/campaigns/custom_uploads/`, {
            source_url: url,
            source_type: source_type,
            publish_to: publishTo,
            caption: caption,
            schedule_date: schedule_date,
        })
    },

    createVideoCampaign: (
        title,
        url,
        targetClipLength,
        enableCaptions,
        removeSilence
    ) => {
        return config.post(`/api/campaigns/video_submissions/`, {
            title: title,
            source_url: url,
            target_clip_length: targetClipLength,
            subtitle_switch: enableCaptions,
            remove_silence_switch: removeSilence,
        })
    },
}
